import { render } from "./IconBlueFolderOpen.vue?vue&type=template&id=656e887e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBlueFolderOpen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "656e887e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('656e887e', __exports__)) {
    api.reload('656e887e', __exports__)
  }
  
  module.hot.accept("./IconBlueFolderOpen.vue?vue&type=template&id=656e887e", () => {
    api.rerender('656e887e', render)
  })

}


export default __exports__